// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__1PzjB","paymentContainer":"PaymentPage_paymentContainer__GOnjz"};